define.alias("shared/utils/formatters/format-hashtag-trends", "calendar/utils/formatters/format-hashtag-trends");